module.exports = __webpack_public_path__ + "img/logo.7ed9b80b.png";